import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { NavLink } from 'react-router-dom';

import Logo from './Logo';
import ProfileMenu from './ProfileMenu';
import { commonStyles, COLORS } from '../styles/styles';
import {selectedProgram, selectedModule} from '../redux/selectors'

import avatar from '../assets/avatar.jpg';

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import logoLong from '../assets/CPS_long.png';
import logoShort from '../assets/icon_new.svg';

import AvatarCirce from './AvatarCircle';
import { authAdminRequest, authUserRequest, getTokenFromCookies, logoutUserRequest } from '../redux/reducers/login';
import logoSmall from '../assets/logo.svg'
import { getUserProgramsFullRequest, selectUserPrograms, resetUserPrograms } from '../redux/reducers/userProgramsFull';
import {showMessageCenter} from '../redux/reducers/messagesList'

import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBDropdown,
  MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBContainer, MDBIcon, MDBBadge, MDBAnimation } from "mdbreact";
import authHOC from './AuthHOC';

import { getTeamMembersFullRequest, selectMessage,resetSelectionMessage } from '../redux/reducers/teamMembersFull';
import { STORAGE_LINK } from '../constants';
  
  
  class Header extends Component {
    state = {
      collapseID: ""
    };
    
    toggleCollapse = collapseID => () =>
      this.setState(prevState => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : ""
    }));
    
    render() {
      const { classes} = this.props;
      return (
        
          <MDBNavbar style={{zIndex:2080}} color="default-color" dark expand="md" fixed="top">
            <MDBNavbarBrand>
            <div className="d-none d-md-block">
              <img className="longLogo" src={logoLong} />
            </div>
            <div className="d-block d-md-none">
            <img style={{height:42}} src={logoShort} />
            </div>
            </MDBNavbarBrand>
            
            {/* <MDBNavbarToggler onClick={this.toggleCollapse("navbarCollapse3")} />
            <MDBCollapse id="navbarCollapse3" isOpen={this.state.collapseID} navbar>
              <MDBNavbarNav right>
                <MDBNavItem active>
                  <MDBNavLink onClick={() => {
         this.props.logoutUserRequest(this.props.loginReducer.token);
         localStorage.setItem('firstShowTourPopup', false);
       }}>Logout</MDBNavLink>
                </MDBNavItem>
              </MDBNavbarNav>
            </MDBCollapse> */}

            <MDBNavbarNav className="userNav" right>
            <MDBNavItem active>
                  <MDBNavLink to='#!' onClick={() => {
         this.props.logoutUserRequest(this.props.loginReducer.token);
         localStorage.setItem('firstShowTourPopup', false);
       }} style={{marginTop:12}}>Logout</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem style={{width:45}}>
                  <MDBDropdown>
                    <MDBDropdownToggle className="dopdown-toggle" nav>
                      
                      <div style={{position: 'relative'}}>

                        {this.props.loginReducer.user.avatar ? <img src={STORAGE_LINK+this.props.loginReducer.user.avatar} className="rounded-circle z-depth-0"
                          style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px", padding: 0, position: 'absolute', zIndex: 1, top: -5}} alt="" />
                      : <img src={avatar} className="rounded-circle z-depth-0"
                      style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px", padding: 0, position: 'absolute', zIndex: 1, top: -5}} alt="" />
                        }
                    </div>
                    </MDBDropdownToggle>
                    {/* <MDBDropdownMenu className="dropdown-default" right>
                      <MDBDropdownItem href="#!">Deactivate Account</MDBDropdownItem>
                      <MDBDropdownItem onClick={() => {
         
                          this.props.logoutUserRequest(this.props.loginReducer.token);
                          localStorage.setItem('firstShowTourPopup', false);
                        }}>Log out</MDBDropdownItem>
                    </MDBDropdownMenu> */}
                  </MDBDropdown>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink to='#!'>
                  {(this.props.loginReducer.user && this.props.loginReducer.user.numberOfUnreadMessages!=0) ? <MDBAnimation type="pulse" infinite>
                    <div className={classes.mailBadge} onClick={()=>this.props.showMessageCenter(true)}>
                      <MDBIcon far icon="envelope" className="ml-1" size="lg" />
                      <MDBBadge className="badge-pill-round"  color="danger-color">{this.props.loginReducer.user && this.props.loginReducer.user.numberOfUnreadMessages}</MDBBadge>
                    </div>
                    </MDBAnimation> : 
                    <div className={classes.mailBadge} onClick={()=>this.props.showMessageCenter(true)}>
                      <MDBIcon far icon="envelope" className="ml-1" size="lg" />
                    </div>
                    }
                  </MDBNavLink>
                </MDBNavItem>
              </MDBNavbarNav>
          </MDBNavbar>
        );
      }
    }

const styles = theme => ({
  ...commonStyles,
  mainHeaderTitle: {
    marginRight: 30,
    marginLeft: 400,
    color: '#fff',
    fontWeight: theme.typography.fontWeightLight,
    fontSize: theme.typography.fontSize,
    letterSpacing: 0.5,
    textAlign: 'right',
    display: 'inline-block',
    paddingTop:10
  },
  mainHeader: {
    backgroundColor: '#8a272a',
    boxShadow: '0 4px 5px 0 rgba(0,0,0,0.24)',
    height: 47,
  },
  toolbar: {
    minHeight: 35,
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: 455,
  },
  mainHeaderNav: {
    width: '100%',
  },
  mainHeaderNavLink: {
    textTransform: 'uppercase',
    padding: '10px 0',
    textDecoration: 'none',
    color: '#fff',
    fontWeight: 240,
  },
  mainHeaderNavLinkActive: {
    fontWeight: 400,
  },
  mainHeaderNavTitle: {
    fontSize: '1rem',
    display: 'inline-block',
    padding: '16px 20px 0px 20px',
  },
  mailBadge:{
    position: 'relative',    
    marginTop: 12,
    marginRight: 15
  }
});

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  getProgram: selectedProgram(state),
  view: state.viewReducer,
  userProgramsFull: state.userProgramsFullReducer,
});

const mapDispatchToProps = dispatch => ({
  showMessageCenter: bool => dispatch(showMessageCenter(bool)),
  getTeamMembersFullRequest: () => dispatch(getTeamMembersFullRequest()),
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  toggleRefererPage: value => dispatch(toggleRefererPage(value)),
  logoutUserRequest: token => dispatch(logoutUserRequest(token)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  authHOC,
  withStyles(styles),
)(Header);

Header.propTypes = {
  classes: PropTypes.instanceOf(Object),
  loginReducer: PropTypes.instanceOf(Object),
  location: PropTypes.instanceOf(Object),
};



// WEBPACK FOOTER //
// ./src/Components/Header.jsx